import _ from 'lodash'

type CONFIG_TYPE = {
    FICTIV_API_BASE: string
    FICTIV_JS_RELEASE_ID: string
    WB_DOMAIN: string
    ODOO_DOMAIN: string
    APPCUES_APP_ID: string
    DRIFT_APP_ID: string
    HAS_OVERRIDES: boolean
    GRAPHQL_API_BASE: string
    GRAPHQL_API_REST_BASE: string
    HEAP_APP_ID: string
    MARKETO_APP_ID: string
    USE_LOGGER: boolean
    SENTRY_FRONTEND_DSN: string
    SENTRY_CURRENT_ENV: string
    IS_PROD: string
    MAINTENANCE_NOTICE_TOGGLE: boolean
    MAINTENANCE_NOTICE_DATETIME_START: number
    MAINTENANCE_NOTICE_DATETIME_END: number
    GTM_ID: string
    STRIPE_PUBLISHABLE_KEY: string
    FICTIV_JS_CDN_PATH: string
    DISABLE_SIGNUP: boolean
    PDFTRON_PDFNETJS_LIC: string
    REGIONAL_CONFIGS: Record<string, any>
    HOTJAR_ID: string
    SFDC_URL: string
    ATTRIBUTION_ID: string
    VWO_SDK_KEY?: string
    VWO_ACCOUNT_ID?: string
}

const PARSERS: Record<string, any> = {
    string: (val = '') => String(val || ''),
    boolean: (val = 'false') => String(val) === 'true',
    number: (val = null) => _.toFinite(val) || null,
    json: (val = '{}') => JSON.parse(val) || {},
}

type CONFIG_KEYS = keyof CONFIG_TYPE

const CONFIG_DEFINITION: Record<CONFIG_KEYS, string> = {
    FICTIV_API_BASE: 'string',
    FICTIV_JS_RELEASE_ID: 'string',
    WB_DOMAIN: 'string',
    ODOO_DOMAIN: 'string',
    APPCUES_APP_ID: 'string',
    DRIFT_APP_ID: 'string',
    HAS_OVERRIDES: 'boolean',
    GRAPHQL_API_BASE: 'string',
    GRAPHQL_API_REST_BASE: 'string',
    HEAP_APP_ID: 'string',
    MARKETO_APP_ID: 'string',
    USE_LOGGER: 'boolean',
    SENTRY_FRONTEND_DSN: 'string',
    SENTRY_CURRENT_ENV: 'string',
    IS_PROD: 'string',
    MAINTENANCE_NOTICE_TOGGLE: 'boolean',
    MAINTENANCE_NOTICE_DATETIME_START: 'number',
    MAINTENANCE_NOTICE_DATETIME_END: 'number',
    GTM_ID: 'string',
    STRIPE_PUBLISHABLE_KEY: 'string',
    FICTIV_JS_CDN_PATH: 'string',
    DISABLE_SIGNUP: 'boolean',
    PDFTRON_PDFNETJS_LIC: 'string',
    REGIONAL_CONFIGS: 'json',
    HOTJAR_ID: 'string',
    SFDC_URL: 'string',
    ATTRIBUTION_ID: 'string',
    VWO_SDK_KEY: 'string',
    VWO_ACCOUNT_ID: 'string',
}

const CONFIG: Partial<CONFIG_TYPE> = {}

let isStarted = false

export function setenv(input: typeof CONFIG) {
    if (isStarted) {
        throw new Error('already called setenv')
    }

    ;(Object.keys(CONFIG_DEFINITION) as CONFIG_KEYS[]).forEach(key => {
        const valueType = CONFIG_DEFINITION[key] || 'string'
        const parser = PARSERS[valueType]

        CONFIG[key] = parser(input[key])
    })

    isStarted = true
}

export function getenv<T extends CONFIG_KEYS>(name: T) {
    if (!isStarted) {
        throw new Error('attempted to getenv before setenv was called')
    }

    if (Object.prototype.hasOwnProperty.call(CONFIG, name)) {
        return CONFIG[name] as CONFIG_TYPE[T]
    }

    throw new Error(`no config named '${name}'`)
}
